import { StringCol } from '../string/string-col';

export class GuidCol extends StringCol {}
